export default __webpack_public_path__ + "static/media/bgvendas.1cef9213.png";